// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__BFNQf","infoBtn":"quickbooks_infoBtn__1HUcq","formBox":"quickbooks_formBox__1B0eS","formFooter":"quickbooks_formFooter__2tWpe"};